/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React from "react"
import { GlobalContextProvider } from "./src/context/GlobalContext"
import QueryParameterProvider from "./src/context/QueryParameterContext"
import { FilesProvider } from "./src/context/FilesContext"

export const wrapRootElement = ({ element }) => {
  return (
    <GlobalContextProvider>
      <QueryParameterProvider>
        <FilesProvider>{element}</FilesProvider>
      </QueryParameterProvider>
    </GlobalContextProvider>
  )
}
